import { confirmLogout } from "@/lib/confirmLogout";
import { Link } from "react-router-dom";
import { PlayCircle, LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { NotificationBell } from "@/components/NotificationBell";
import { KpiAlertBell } from "@/components/kpi/KpiAlertBell";
import { TopSearch } from "@/components/layout/TopSearch";
import { hasGuide } from "@/tours/guides";
import { GuideMenu } from "@/components/layout/GuideMenu";

/** Top right corner of the top bar: notifications, who is signed in, and log out. */
export function TopUser({ moduleId }) {
  const { user, logout } = useAuth();
  const initials = (user?.full_name || "U").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  return (
    <div data-testid="topbar-user" className="ml-auto flex shrink-0 items-center gap-2">
      <TopSearch />
      <KpiAlertBell />
      <NotificationBell compact variant="topbar" />
      {hasGuide(moduleId) && <GuideMenu moduleId={moduleId} />}
      <button type="button" data-testid="take-tour-button" data-tour="take-tour" title="Take a tour" aria-label="Take a tour"
        onClick={() => window.dispatchEvent(new Event("buildnexa:start-tour"))}
        className="hidden h-10 shrink-0 items-center gap-2 rounded-[10px] border border-white/20 bg-white/[0.04] px-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10 md:flex">
        <PlayCircle className="h-[18px] w-[18px]" /> <span className="hidden xl:inline">Take a tour</span>
      </button>
      <span title={user?.full_name} className="ml-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#99002B] text-sm font-bold text-white">{initials}</span>
      <div className="hidden min-w-0 max-w-[160px] sm:block">
        <p className="truncate text-sm font-semibold leading-tight text-white" data-testid="current-user-name">{user?.full_name}</p>
        <p className="mt-0.5 truncate text-[10.5px] font-semibold leading-tight tracking-wide text-[#FF8FA8]" data-testid="current-user-role">{user?.role}</p>
      </div>
      <Link to="/erp/account/security" data-testid="security-link" title="Two-step sign-in" aria-label="Two-step sign-in"
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] text-[#C5CFE6] transition-colors hover:bg-white/10 hover:text-white">
        <ShieldCheck className="h-5 w-5" />
      </Link>
      <button data-testid="logout-button" onClick={() => confirmLogout(logout)} title="Log out" aria-label="Log out"
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] text-[#E6EBF5] transition-colors hover:bg-[#99002B] hover:text-white">
        <LogOut className="h-5 w-5" />
      </button>
    </div>
  );
}
